module.exports = __webpack_public_path__ + "static/img/ninja-can-20.44ba5c2b.png";